import Axios from 'axios';
import { handleErrors } from './utils';

const IPDATA_KEY = 'e040a8eb9552ca02494ef5c9c95ab758615ff860d1d805c6c1a488fd';

export function getGeoData() {
    return new Promise((resolve, reject) => {
        Axios.get(`https://api.ipdata.co/?api-key=${IPDATA_KEY}`)
            .then(({ data }) => resolve(data))
            .catch(handleErrors(reject));
    });
}
